import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/chuku_ic_cangku@2x.png'
import _imports_1 from '@/assets/icon/gongdan_ic_shoudong@2x.png'
import _imports_2 from '@/assets/icon/chuku_ic_delete@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-e63c7d40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 0,
  class: "page_info"
}
const _hoisted_3 = { class: "page_info_title" }
const _hoisted_4 = { class: "page_info_list" }
const _hoisted_5 = { class: "page_info_list_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "来源类型：", -1))
const _hoisted_7 = {
  key: 0,
  class: "page_info_list_item_nr"
}
const _hoisted_8 = {
  key: 1,
  class: "page_info_list_item_nr"
}
const _hoisted_9 = {
  key: 2,
  class: "page_info_list_item_nr"
}
const _hoisted_10 = {
  key: 3,
  class: "page_info_list_item_nr"
}
const _hoisted_11 = {
  key: 4,
  class: "page_info_list_item_nr"
}
const _hoisted_12 = {
  key: 5,
  class: "page_info_list_item_nr"
}
const _hoisted_13 = { class: "page_info_list_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "来源单号：", -1))
const _hoisted_15 = { class: "page_info_list_item_nr" }
const _hoisted_16 = { class: "page_info_list_item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "申请人员：", -1))
const _hoisted_18 = { class: "page_info_list_item_nr" }
const _hoisted_19 = { class: "page_info_list_item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "入库接收人：", -1))
const _hoisted_21 = { class: "page_info_list_item_nr" }
const _hoisted_22 = { class: "page_info_list_item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "申请时间：", -1))
const _hoisted_24 = { class: "page_info_list_item_nr" }
const _hoisted_25 = {
  key: 0,
  class: "page_info_bz"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_bz_title" }, "转库备注：", -1))
const _hoisted_27 = { class: "page_info_bz_nr" }
const _hoisted_28 = {
  key: 1,
  class: "page_info"
}
const _hoisted_29 = { class: "page_info_title" }
const _hoisted_30 = { class: "page_info_list" }
const _hoisted_31 = { class: "page_info_list_item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "来源类型：", -1))
const _hoisted_33 = {
  key: 0,
  class: "page_info_list_item_nr"
}
const _hoisted_34 = {
  key: 1,
  class: "page_info_list_item_nr"
}
const _hoisted_35 = {
  key: 2,
  class: "page_info_list_item_nr"
}
const _hoisted_36 = {
  key: 3,
  class: "page_info_list_item_nr"
}
const _hoisted_37 = {
  key: 4,
  class: "page_info_list_item_nr"
}
const _hoisted_38 = {
  key: 5,
  class: "page_info_list_item_nr"
}
const _hoisted_39 = { class: "page_info_list_item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "来源单号：", -1))
const _hoisted_41 = { class: "page_info_list_item_nr" }
const _hoisted_42 = { class: "page_info_list_item" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "申请人员：", -1))
const _hoisted_44 = { class: "page_info_list_item_nr" }
const _hoisted_45 = { class: "page_info_list_item" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "申请时间：", -1))
const _hoisted_47 = { class: "page_info_list_item_nr" }
const _hoisted_48 = {
  key: 0,
  class: "page_info_bz"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_bz_title" }, "转库备注：", -1))
const _hoisted_50 = { class: "page_info_bz_nr" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_h" }, null, -1))
const _hoisted_52 = { class: "page_sfq" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_dck" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page_dck_title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "page_dck_title_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "待出库物料")
  ])
], -1))
const _hoisted_55 = { class: "page_content_title" }
const _hoisted_56 = { class: "page_content_title_top" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("待出 ")
const _hoisted_58 = { class: "page_content_title_bottom" }
const _hoisted_59 = {
  key: 0,
  class: "green"
}
const _hoisted_60 = {
  key: 1,
  class: "warning"
}
const _hoisted_61 = {
  key: 2,
  class: "error"
}
const _hoisted_62 = { key: 3 }
const _hoisted_63 = { class: "page_content_list_item" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_content_list_item_label" }, "出库货位：", -1))
const _hoisted_65 = { class: "page_content_list_item_nr" }
const _hoisted_66 = { class: "page_content_list_items" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_content_list_item_label" }, "数量：", -1))
const _hoisted_68 = { class: "page_content_list_item_nr" }
const _hoisted_69 = { class: "page_content_list_item" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_content_list_item_label" }, "批次号：", -1))
const _hoisted_71 = { class: "page_content_list_item_nr" }
const _hoisted_72 = {
  key: 0,
  class: "page_sfq"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_dck" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page_dck_title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "page_dck_title_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "待出库物料")
  ])
], -1))
const _hoisted_75 = { class: "page_content_title" }
const _hoisted_76 = { class: "page_content_title_top" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode("待出 ")
const _hoisted_78 = { class: "page_content_title_bottom" }
const _hoisted_79 = {
  key: 0,
  class: "green"
}
const _hoisted_80 = {
  key: 1,
  class: "warning"
}
const _hoisted_81 = {
  key: 2,
  class: "error"
}
const _hoisted_82 = { key: 3 }
const _hoisted_83 = { class: "page_content_list_item" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_content_list_item_label" }, "批次号：", -1))
const _hoisted_85 = { class: "page_content_list_item_nr" }
const _hoisted_86 = { class: "page_content_list_items" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_content_list_item_label" }, "数量：", -1))
const _hoisted_88 = { class: "page_content_list_item_nr" }
const _hoisted_89 = {
  key: 0,
  class: "page_content_list_item"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_content_list_item_label" }, "出库货位：", -1))
const _hoisted_91 = { class: "page_content_list_item_nr" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_h" }, null, -1))
const _hoisted_93 = { class: "page_yxwl" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page_yxwl_title_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "已选择物料")
], -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手动出库", -1))
const _hoisted_97 = [
  _hoisted_95,
  _hoisted_96
]
const _hoisted_98 = {
  key: 0,
  class: "page_yxwl_list"
}
const _hoisted_99 = { class: "page_yxwl_list_item_top" }
const _hoisted_100 = { class: "page_yxwl_list_item_top_left" }
const _hoisted_101 = { class: "page_yxwl_list_item_sx" }
const _hoisted_102 = {
  key: 0,
  class: "green"
}
const _hoisted_103 = /*#__PURE__*/_createTextVNode("合格 ")
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_105 = [
  _hoisted_103,
  _hoisted_104
]
const _hoisted_106 = {
  key: 1,
  class: "yellow"
}
const _hoisted_107 = /*#__PURE__*/_createTextVNode("不良 ")
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_109 = [
  _hoisted_107,
  _hoisted_108
]
const _hoisted_110 = {
  key: 2,
  class: "red"
}
const _hoisted_111 = /*#__PURE__*/_createTextVNode("报废 ")
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_113 = [
  _hoisted_111,
  _hoisted_112
]
const _hoisted_114 = { key: 3 }
const _hoisted_115 = { class: "page_yxwl_list_item_num" }
const _hoisted_116 = { class: "item" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "出库货位：", -1))
const _hoisted_118 = { class: "nr" }
const _hoisted_119 = { class: "item" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "数量：", -1))
const _hoisted_121 = { class: "nr" }
const _hoisted_122 = ["onUpdate:modelValue"]
const _hoisted_123 = ["onClick"]
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_125 = [
  _hoisted_124
]
const _hoisted_126 = {
  key: 1,
  class: "page_yxwl_kong"
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_zw" }, null, -1))
const _hoisted_130 = { class: "page_footer" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确认出库", -1))
const _hoisted_132 = [
  _hoisted_131
]

import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from "vue-router"
import { Toast } from 'vant'
import { QRCodeType } from '@/enum'
import {
  outScanAppliances,
  wTransferForInOut,
  wTransferForInOutUpload,
  wOutBoundForInOut,
  wOutBoundForUpload,
  transferToOutNew
} from '@/apis/ExWarehouse'
import { useStore } from 'vuex'
import { getDB } from '@/apis/agencyAPI'
import Access from '@/components/common/Access.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()
const router = useRouter()

let dataItem: any = null    // 已扫数据

let show = ref<boolean>(false)
let ids = ref<string>('')   // 已选
let warehouseId = ref('')  // 仓库id
let outboundList = ref<any[]>([])  // 出库数据
// 控制扫码显示隐藏
const openCode = ref<boolean>(false)

// 出库类型
let type: any = route.query.type

const activeNames = ref(['1']);

// 详情数据
let info: any = ref({})

// 打开手动选择工装弹框
const openxz = () => {
  let arr: any = []
  if (info.value.wtransferRedisCodeBeanList.length !== 0) {
    info.value.wtransferRedisCodeBeanList.forEach((element: any) => {
      arr.push(element.appliancesId)
    })
    ids.value = arr.join(',')
  } else {
    ids.value = ''
  }
  show.value = true
}

const closeBox = () => {
  show.value = false
}

const changeNum = (item: any) => {
  info.value.wtransferWarehouseList[0].wtransferDetailList.forEach((row: any) => {
    if (row.materialId === item.materialId) {
      if (Number(item.num) > Number(row.outPlannum)) {
        item.num = 0
        Toast.fail({ message: "出库物料数量不能大于待出库物料数量" })
      }
    }
  })
}

// 提交工装
const getValue = async (val: any, i: number) => {
  // if (i === 0) {
  show.value = false
  // }


  for (let i = 0; i < info.value.wtransferWarehouseList[0].wtransferDetailList.length; i++) {
    if (info.value.wtransferWarehouseList[0].wtransferDetailList[i].materialId == val.materialId &&
      info.value.wtransferWarehouseList[0].wtransferDetailList[i].procedureId == val.procedureId &&
      info.value.wtransferWarehouseList[0].wtransferDetailList[i].qualityType == val.qualityType &&
      info.value.wtransferWarehouseList[0].wtransferDetailList[i].batch == val.batch) {

      for (let s = 0; s < outboundList.value.length; s++) {
        if (outboundList.value[s].newId == info.value.wtransferWarehouseList[0].wtransferDetailList[i].id) {
          return Toast.fail({ message: "该物料批次已存在" })
        }
      }

      let obj = JSON.parse(JSON.stringify(val))
      obj.newId = info.value.wtransferWarehouseList[0].wtransferDetailList[i].id
      outboundList.value.push(obj)

    }
  }

  console.log(outboundList.value)
  // let res = await outScanAppliances({
  //     barCode: val.prefix + val.code,
  //     pId: info.value.wtransfer.id,
  //     type: 1
  // })
  // if (res.code === 200) {
  //     let isData: string = ''
  //     info.value.wtransferWarehouseList.forEach((item: any) => {
  //         if (res.data.warehouseId === item.warehouseId) {
  //             item.wtransferDetailList.forEach((item1: any) => {
  //                 if (item1.materialId !== res.data.materialId) {
  //                     isData = 'wl'
  //                 } else if (res.data.qualityType !== item1.qualityType) {
  //                     isData = 'lx'
  //                 } else if (res.data.procedureId !== item1.procedureId) {
  //                     isData = 'gx'
  //                 } else if (item1.batch ? res.data.batch !== item1.batch : false) {
  //                     isData = 'pc'
  //                 } else {
  //                     isData = ''
  //                 }
  //                 if (item1.materialId == res.data.materialId && res.data.qualityType == item1.qualityType && res.data.procedureId == item1.procedureId && item1.batch ? res.data.batch == item1.batch : true) {
  //                     dataItem = res.data
  //                     dataItem.wtransferDetailId = item1.id
  //                     dataItem.wtransferId = item1.transferId
  //                     dataItem.appliancesId = res.data.id
  //                     let rul = upload()
  //                     return;
  //                 }
  //             })
  //         } else {
  //             isData = 'ck'
  //         }
  //         if (isData === 'ck') {
  //             Toast.fail({ message: "仓库不一致" })
  //         } else if (isData === 'wl') {
  //             Toast.fail({ message: "物料不一致" })
  //         } else if (isData === 'lx') {
  //             Toast.fail({ message: "质量类型不一致" })
  //         } else if (isData === 'gx') {
  //             Toast.fail({ message: "工序不一致" })
  //         } else if (isData === 'pc') {
  //             Toast.fail({ message: "批次不一致" })
  //         }
  //     })
  // }
  // show.value = false
}

// 获取详情 (转库单/出库单)
const getInfo = () => {
  let type: string = route.query.type as string
  if (type === QRCodeType.CKD.toString()) {
    console.log('出库单')
    wOutBoundForInOut({
      id: Number(route.query.id),
      wOutboundType: 0
    }).then(res => {
      if (res.code === 200) {
        info.value = res.data
        warehouseId.value = info.value.wtransferWarehouseList[0].warehouseId.toString()
      } else {
        Toast.fail({ message: res.message, forbidClick: true, duration: 2000 })
        setTimeout(() => {
          router.go(-1)
        }, 2000)
      }
    })
  } else if (type === QRCodeType.ZKD.toString()) {
    console.log('转库单')
    wTransferForInOut({
      id: Number(route.query.id),
      wTransferType: 0
    }).then(res => {
      if (res.code === 200) {
        info.value = res.data
        warehouseId.value = info.value.wtransferWarehouseList[0].warehouseId.toString()
      } else {
        Toast.fail({ message: res.message, forbidClick: true, duration: 2000 })
        setTimeout(() => {
          router.go(-1)
        }, 2000)
      }
    })
  }
}

// 删除对应的批次
const dele = (index: Number) => {
  outboundList.value.forEach((item: any, i: number) => {
    if (index === i) {
      outboundList.value.splice(i, 1)
    }
  })
}

// 上传工装
const upload = () => {
  if (type === QRCodeType.ZKD.toString()) {
    wTransferForInOut({
      id: Number(route.query.id),
      optType: 1,
      wTransferType: 0,
      jsonBean: dataItem
    }).then(res => {
      if (res.code === 200) {
        getInfo()
      }
    })
  } else if (type === QRCodeType.CKD.toString()) {
    wOutBoundForInOut({
      id: Number(route.query.id),
      optType: 1,
      wOutboundType: 0,
      jsonBean: dataItem
    }).then(res => {
      if (res.code === 200) {
        getInfo()
      }
    })
  }
}

// 点击扫码出库
const ck = () => {
  openCode.value = true
}

// 提交操作
const submit = () => {
  if (type === QRCodeType.ZKD.toString()) {
    if (outboundList.value.length > 0) {
      let result = outboundList.value.reduce((a, b) => {
        if (a[b.newId]) {
          a[b.newId].push(b);
        } else {
          a[b.newId] = [b];
        }
        return a;
      }, {});

      for (let i = 0; i < info.value.wtransferWarehouseList[0].wtransferDetailList.length; i++) {
        for (let a in result) {
          if (info.value.wtransferWarehouseList[0].wtransferDetailList[i].id == a) {
            let total = 0
            for (let b = 0; b < result[a].length; b++) {
              total = Number(total) + Number(result[a][b].num)
            }
            console.log(total, info.value.wtransferWarehouseList[0].wtransferDetailList[i].outPlannum)
            if (!total || total <= 0) {
              return Toast.fail({ message: '出库物料数量必须大于0', forbidClick: true, duration: 2000 })
            }
            if (total > info.value.wtransferWarehouseList[0].wtransferDetailList[i].outPlannum) {
              return Toast.fail({ message: '出库数量不能大于待出库数量', forbidClick: true, duration: 2000 })
            }
          }
        }
      }

      let submitTransferOutDetailDTOList: any = []
      outboundList.value.forEach((item: any) => {
        info.value.wtransferWarehouseList[0].wtransferDetailList.forEach((child: any) => {
          if (item.newId == child.id) {
            submitTransferOutDetailDTOList.push({
              outNum: item.num,
              wstockId: item.id,
              wtransferDetailId: child.id
            })
          }
        })
      })
      transferToOutNew({
        submitTransferOutDetailDTOList,
        wtransferId: route.query.id
      }).then(res => {
        if (res.code === 200) {
          store.dispatch('getUpcomingNum')
          Toast.success({ message: '操作成功', forbidClick: true, duration: 2000 })
          setTimeout(() => {
            router.replace({ name: 'wTransferDetail', query: { id: info.value.wtransfer.id, dbid: route.query.dbid } })
          }, 2000)
        }
      })
    } else {
      Toast.fail({ message: '请选择出库物料', forbidClick: true, duration: 2000 })
    }
    // let yx: number = 0
    // let dc: number = 0
    // info.value.wtransferRedisCodeBeanList.forEach((element: any) => {
    //     yx = yx + element.num
    // })
    // info.value.wtransferWarehouseList.forEach((element: any) => {
    //     element.wtransferDetailList.forEach((elementChilder: any) => {
    //         dc = dc + elementChilder.outPlannum
    //     })
    // })
    // if (yx < dc) {
    //     Dialog.confirm({
    //         title: '提示',
    //         message: '待出物料与已出物料数量不一致，是否确认出库',
    //     })
    //     .then(() => {
    //         wTransferForInOutUpload({
    //             id: info.value.wtransfer.id,
    //             wTransferType: 0
    //         }).then(res => {
    //             if (res.code === 200) {
    //                 store.dispatch('getUpcomingNum')
    //                 Toast.success({ message: '操作成功', forbidClick: true, duration: 2000 })
    //                 setTimeout(() => {
    //                     // router.go(-1)
    //                     router.replace({ name: 'wTransferDetail', query: { id: info.value.wtransfer.id, dbid: route.query.dbid } })
    //                 }, 2000)
    //             }
    //         })
    //         return
    //     })
    //     .catch(() => {

    //     });
    // } else {
    //     wTransferForInOutUpload({
    //         id: info.value.wtransfer.id,
    //         wTransferType: 0
    //     }).then(res => {
    //         if (res.code === 200) {
    //             store.dispatch('getUpcomingNum')
    //             Toast.success({ message: '操作成功', forbidClick: true, duration: 2000 })
    //             setTimeout(() => {
    //                 // router.go(-1)
    //                 router.replace({ name: 'wTransferDetail', query: { id: info.value.wtransfer.id, dbid: route.query.dbid } })
    //             }, 2000)
    //         }
    //     })
    // }
  } else if (type === QRCodeType.CKD.toString()) {
    wOutBoundForUpload({
      id: info.value.woutbound.id,
      wOutboundType: 0
    }).then(res => {
      if (res.code === 200) {
        store.dispatch('getUpcomingNum')
        Toast.success({ message: '操作成功', forbidClick: true, duration: 2000 })
        setTimeout(() => {
          // router.go(-1)
          router.replace({ name: 'wOutboundDetail', query: { id: info.value.wtransfer.id } })
        }, 2000)
      }
    })
  }
}

// 获取待办详情(判断当前待办是否已处理)
const getDBs = async (id: string): Promise<any> => {
  let res = await getDB(id)
  if (res.code === 200) {
    if (res.data.status === 1) {
      if (type === QRCodeType.CKD.toString()) {
        await router.replace({ name: 'wOutboundDetail', query: { id: route.query.id } })
      } else if (type === QRCodeType.ZKD.toString()) {
        await router.replace({ name: 'wTransferDetail', query: { id: route.query.id } })
      }
    } else {
      await getInfo()
    }
  }
}

onMounted(() => {
  if (route.query.dbid) {
    getDBs(route.query.dbid as string)
  } else {
    getInfo()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(info).wtransfer && _unref(route).query.type == 7)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "计划出库日期：" + _toDisplayString(_unref(info).wtransfer.outPlandate), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (_unref(info).wtransfer.originType === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "采购订单"))
                : (_unref(info).wtransfer.originType === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "生产工单"))
                  : (_unref(info).wtransfer.originType === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, "销售订单"))
                    : (_unref(info).wtransfer.originType === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "转库单"))
                      : (_unref(info).wtransfer.originType === 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, "盘点单"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, "-"))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(info).wtransfer.originCode ? _unref(info).wtransfer.originCode : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(info).wtransfer.outUserName) + "/" + _toDisplayString(_unref(info).wtransfer.outDepartName), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(info).wtransfer.inUserName), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(info).wtransfer.createTime ? _unref(info).wtransfer.createTime : '-'), 1)
            ])
          ]),
          (_unref(info).wtransfer.abstracts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(info).wtransfer.abstracts), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(info).woutbound && _unref(route).query.type == 8)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, "计划出库日期：" + _toDisplayString(_unref(info).woutbound.planDate), 1),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              (_unref(info).woutbound.originType === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, "采购订单"))
                : (_unref(info).woutbound.originType === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, "生产工单"))
                  : (_unref(info).woutbound.originType === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, "销售订单"))
                    : (_unref(info).woutbound.originType === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, "转库单"))
                      : (_unref(info).woutbound.originType === 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, "盘点单"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_38, "-"))
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(info).woutbound.originCode ? _unref(info).woutbound.originCode : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(info).woutbound.userName) + "/" + _toDisplayString(_unref(info).woutbound.userDepartName), 1)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(info).woutbound.createTime ? _unref(info).woutbound.createTime : '-'), 1)
            ])
          ]),
          (_unref(info).woutbound.abstracts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(info).woutbound.abstracts), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_51,
    _createVNode(_component_van_collapse, {
      modelValue: activeNames.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeNames).value = $event))
    }, {
      default: _withCtx(() => [
        (_unref(route).query.type == 7)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(info).wtransferWarehouseList, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_collapse_item, {
                name: String(index + 1),
                key: index
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createTextVNode(" " + _toDisplayString(item.warehouseName), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _hoisted_54,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.wtransferDetailList, (items, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "page_content",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("span", null, _toDisplayString(items.materialName) + " | " + _toDisplayString(items.materialCode), 1),
                          _createElementVNode("span", null, [
                            _hoisted_57,
                            _createElementVNode("span", null, _toDisplayString(items.outPlannum), 1),
                            _createTextVNode(" " + _toDisplayString(items.unitName), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          (items.qualityType === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_59, "合格 / "))
                            : (items.qualityType === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_60, "不良 / "))
                              : (items.qualityType === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_61, "报废 / "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_62, "- / ")),
                          _createElementVNode("span", null, _toDisplayString(items.procedureName ? items.procedureName : '-') + " / ", 1),
                          _createElementVNode("span", null, _toDisplayString(items.batch ? items.batch : '-'), 1)
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.wstockExtListVOList, (childer, idxs) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "page_content_list",
                          key: idxs
                        }, [
                          _createElementVNode("div", _hoisted_63, [
                            _hoisted_64,
                            _createElementVNode("div", _hoisted_65, _toDisplayString(childer.locationName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _hoisted_67,
                            _createElementVNode("div", _hoisted_68, _toDisplayString(childer.num) + _toDisplayString(childer.unitName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _hoisted_70,
                            _createElementVNode("div", _hoisted_71, _toDisplayString(childer.batch ? childer.batch : '-'), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          : _createCommentVNode("", true),
        (_unref(route).query.type == 8)
          ? (_openBlock(), _createBlock(_component_van_collapse_item, {
              key: 1,
              name: "1"
            }, {
              title: _withCtx(() => [
                (_unref(info).woutbound)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _hoisted_73,
                      _createTextVNode(" " + _toDisplayString(_unref(info).woutbound.warehouseName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _hoisted_74,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).woutboundDetailsWait, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "page_content",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("span", null, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1),
                        _createElementVNode("span", null, [
                          _hoisted_77,
                          _createElementVNode("span", null, _toDisplayString(item.num), 1),
                          _createTextVNode(" " + _toDisplayString(item.unitName), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        (item.qualityType === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_79, "合格 / "))
                          : (item.qualityType === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_80, "不良 / "))
                            : (item.qualityType === 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_81, "报废 / "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_82, "- / ")),
                        _createElementVNode("span", null, _toDisplayString(item.procedureName ? item.procedureName : '-') + " / ", 1),
                        _createElementVNode("span", null, _toDisplayString(item.batch ? item.batch : '-'), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.wstockExtListVOList, (items, ind) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "page_content_list",
                        key: ind
                      }, [
                        _createElementVNode("div", _hoisted_83, [
                          _hoisted_84,
                          _createElementVNode("div", _hoisted_85, _toDisplayString(items.batch ? items.batch : '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_86, [
                          _hoisted_87,
                          _createElementVNode("div", _hoisted_88, _toDisplayString(items.num) + _toDisplayString(items.umodel.name), 1)
                        ]),
                        (items.lmodel)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                              _hoisted_90,
                              _createElementVNode("div", _hoisted_91, _toDisplayString(items.lmodel.unionName), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_92,
    _createElementVNode("div", _hoisted_93, [
      _createElementVNode("div", { class: "page_yxwl_title" }, [
        _hoisted_94,
        _createElementVNode("div", {
          class: "right",
          onClick: openxz
        }, _hoisted_97)
      ]),
      (_unref(outboundList).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(outboundList), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "page_yxwl_list_item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1)
                ]),
                _createElementVNode("div", _hoisted_101, [
                  (item.qualityType == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_102, _hoisted_105))
                    : (item.qualityType == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_106, _hoisted_109))
                      : (item.qualityType == 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_110, _hoisted_113))
                        : (_openBlock(), _createElementBlock("span", _hoisted_114, "- / ")),
                  _createElementVNode("span", null, " " + _toDisplayString(item.procedureName ? item.procedureName : '-') + " / ", 1),
                  _createElementVNode("span", null, " " + _toDisplayString(item.batch ? item.batch : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, [
                    _hoisted_117,
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("span", null, _toDisplayString(item.locationName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _hoisted_120,
                    _createElementVNode("div", _hoisted_121, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                        placeholder: "请输入"
                      }, null, 8, _hoisted_122), [
                        [_vModelText, item.num]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(item.unitName), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "dele",
                    onClick: ($event: any) => (dele(index))
                  }, _hoisted_125, 8, _hoisted_123)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_126, _hoisted_128))
    ]),
    _hoisted_129,
    _createElementVNode("div", _hoisted_130, [
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "page_footer_qrck",
        onClick: submit
      }, _hoisted_132)), [
        [_directive_preventReClick]
      ])
    ]),
    _createVNode(Access, {
      show: _unref(show),
      transferId: (_unref(route).query.id as string),
      warehouseId: _unref(warehouseId),
      onClose: closeBox,
      onValue: getValue
    }, null, 8, ["show", "transferId", "warehouseId"])
  ]))
}
}

})